import { GRAPH_DEFAULTS } from "../Enums/index.js";
import DocumentDO = App.Data.Explorer.DocumentDO;

export const boxedLabel = (derivedDocument: DocumentDO, isDarkMode: boolean) => {
	return {
		backgroundColor: derivedDocument.is_label_box_visible
			? "rgba(255,255,255,0.5)"
			: undefined,
		borderRadius: 0,
		borderWidth: 1,
		borderColor: undefined,
		color:
			isDarkMode
				? GRAPH_DEFAULTS.TEXT_COLOR_DARK
				: GRAPH_DEFAULTS.TEXT_COLOR,
		font: {
			size: 30,
		},
		padding: {
			left: 1,
			right: 1,
			top: 0,
			bottom: 0,
		},
	};
};
